import React from 'react';
import { FormattedMessage } from 'react-intl';

const DeliveryTimeLabel = () => <FormattedMessage defaultMessage='Delivery' description='fulfillmentPlanner.deliveryTime' id='YYtfh9' />;

export default DeliveryTimeLabel;
